import { render, staticRenderFns } from "./picker-aftersales.vue?vue&type=template&id=0495f643"
import script from "./picker-aftersales.vue?vue&type=script&lang=js"
export * from "./picker-aftersales.vue?vue&type=script&lang=js"
import style0 from "./picker-aftersales.vue?vue&type=style&index=0&id=0495f643&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports